import React, { type ReactNode } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';

import { useResizeAnalytics } from '../../performance-profiling/useResizeAnalytics';
import { type ViewportDimensions } from './types';

export const HeightAnalyticsWrapper = ({
	children,
	viewportDimensions,
}: {
	children: ReactNode;
	viewportDimensions?: ViewportDimensions;
}): React.JSX.Element => {
	const isEnabled = fg('forge-ui-app-perf-tracking-enabled');

	const { containerRef } = useResizeAnalytics({
		isEnabled,
		viewportDimensions,
	});

	if (isEnabled) {
		return (
			<div ref={containerRef} id="forge-ui-height-observer-wrapper">
				{children}
			</div>
		);
	}

	return <>{children}</>;
};
